const prefixes = [
  {
    _id: "",
    name: "Select",
    disabled: true,
  },
  {
    _id: 1,
    name: "Dr.",
  },
  {
    _id: 2,
    name: "Prof.",
  },
  {
    _id: 3,
    name: "Mr.",
  },
  {
    _id: 4,
    name: "Ms.",
  },
];

export default prefixes;
